<div class="enquiryMain">
    <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
            styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </div>
    <app-public-header  [company]="company" [branch]="branch"></app-public-header>
    <div class="enquiryBody">
        <div>
            <h1 class="enquiryHeading">Visitor Registration</h1>

        </div>
        <div class="card , formMain">
            <div class="apiResponceMessage"  *ngIf="isMessage">
                <div style=" position: relative;">
                    <p-message class="errors" *ngIf="isMessage && isError" severity="error" text="{{message}}"></p-message>
                    <span style="position: absolute; top: 0; right: 5px; cursor: pointer; font-size: 17px; color: #E9E4D4;" (click)="errorMsgClose()" *ngIf="isError || isSuccess">
                        <i class="fa fa-times"></i>
                    </span>
                </div>
            </div>
            <form class="form" #form="ngForm" (ngSubmit)="submit(form)">
                <div *ngIf="activeIndex == 0">
                <div>
                    <div class="ui-inputgroup , inputMain">
                        <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-user"
                                aria-hidden="true"></i></span>
                        <input class="input" type="text" id="visitorname" #visitor="ngModel" [(ngModel)]="fullName" required
                            pattern="[A-Za-z ]+" autocomplete="off" placeholder="Visitor Name *" maxlength="100" name="name"
                            [ngClass]="visitor.invalid && (visitor.dirty || visitor.touched) ? 'errorInput' : '' ">
                        <div class="errorFixNew" *ngIf="visitor.invalid && (visitor.dirty || visitor.touched)">
                            <div *ngIf="visitor.errors.required" class="errorShow">
                                Please enter your name.
                            </div>
                            <div *ngIf="visitor.errors.pattern" class="errorShow">
                                Your name must contain only letters.
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ui-inputgroup , inputMain">
                        <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-envelope"
                                aria-hidden="true"> </i></span>
                        <input maxlength="256" class="input" #email="ngModel"
                            [ngClass]="email.invalid && (email.dirty || email.touched) ? 'errorInput' : '' "
                            pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" [(ngModel)]="emailAdress" required
                            type="text" id="Email" autocomplete="off" placeholder="Email *" name="email">
                        <div class="errorFixNew">
                            <ng-template [ngIf]="email.invalid && (email.dirty || email.touched)">
                                <div>
                                    <div *ngIf="email.errors.required" class="errorShow">
                                        Please enter your email address.
                                    </div>
                                    <div *ngIf="email.errors.pattern" class="errorShow">
                                        Please enter a valid email. e.g. (john@example.com)
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ui-inputgroup , inputMain">
                        <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-phone"
                                aria-hidden="true"></i></span>
                        <input class="input" type="text" id="mobile" #mobile="ngModel" ngModel
                            [ngClass]="mobile.invalid && (mobile.dirty || mobile.touched) ? 'errorInput' : '' "
                            pattern="(03)[0-9]{9}" autocomplete="off" required placeholder="Mobile *" maxlength="11"
                            name="phone">
                        <div class="errorFixNew" *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)">

                            <div *ngIf="mobile.errors.required" class="errorShow">
                                Please enter your mobile number.
                            </div>
                            <div *ngIf="mobile.errors.pattern" class="errorShow">
                                Please enter a valid mobile number. e.g. {{errorExempleNumber}}
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div class=" ui-inputgroup , inputMain">
                        <span class="ui-inputgroup-addon"><i style="width: 15px !important;" class="fa fa-money"
                            aria-hidden="true"></i></span>
                            <input class="input" type="number" id="visitorFee" #visitorFee="ngModel" [(ngModel)]="selectedBranch.visitorFee"
                            [ngClass]="visitorFee.invalid && (visitorFee.dirty || visitorFee.touched) ? 'errorInput' : ''"
                            autocomplete="off" required placeholder="Visiting Fee PKR *" name="visitorFee" pattern="[0-9]+">
                        <div class="errorFixNew" *ngIf="visitorFee.invalid && (visitorFee.dirty || visitorFee.touched)">
                            <div *ngIf="visitorFee.errors.required" class="errorShow">
                                Please enter the visiting fee.
                            </div>
                            <div *ngIf="visitorFee.errors.pattern" class="errorShow">
                                Please enter a valid visiting fee.
                            </div>
                        </div>
                    </div>
                </div>

                <div class="genderMain">
                    <span class="genderh1">Gender:</span>
                    <div class="genderDiv">
                        <div class="radioMain">
                            <p-radioButton name="gender" value="M" label="Male" id="gender" [(ngModel)]="gender">
                            </p-radioButton>
                        </div>
                        <div>
                            <p-radioButton name="gender" value="F" label="Female" id="gender" [(ngModel)]="gender">
                            </p-radioButton>
                        </div>
                    </div>
                </div>
                <div class="saveMain">
                    <button
                        class="saveButton p-button submitButton p-widget p-state-defaultp-corner-all">
                        <span class="ui-button-text ui-c">
                            <i class="fa fa-save" aria-hidden="true"></i> &nbsp;Save
                        </span>
                     </button>
                    </div>
                 </div>
            </form>
            <div *ngIf="activeIndex == 1" class="thankYou">
                <h2 class="top-heading">
                    Welcome to the GYM
                </h2>
                <div class="center-note thankYou">
                    <p>Your request has been sent for approval. <br/> Your request number is:<span class="first-word-bold">{{requestId}}.</span></p>
                    <p><span class="first-word-bold">Note:</span> Please show your request number at the counter.

                    OR tap <span style="display: inline-flex; align-items: center; margin-right: 5px;">here.</span>
                    <span style="display: inline-flex; align-items: center;"><button pButton pTooltip="Send Request Number" tooltipPosition="top" type="button"
                        style="background-color: #25D366; border: none; border-radius: 50%; padding: 8px; display: flex; align-items: center; width:35px; height: 35px; justify-content: center;">
                        <i class="fa fa-whatsapp" (click)="openWhatsApp()" style="color: white; width: 15px; height: 15px;"></i>
                      </button>
                    </span>
                    </p>
                </div>
                <h3 class="bottom-heading">
                    Thank you for registration.
                </h3>
            </div>
        </div>
    </div>
    <app-public-footer [branch]="branch"></app-public-footer>
</div>
<div id="invoice" style="display: none;">
    <div class="invoice-box" style="padding: 0px !important;  width: 57mm; max-width: 57mm; margin: 0 !important;">
        <div style="width: 57mm;max-width: 57mm;">
            <img [src]=" (companyImage?.bannerImage ? config.Server + 'assets/layout/images/companies/' + companyImage.bannerImage : 'assets/layout/images/logoCompany.png')"
            onerror="this.src=(company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')" alt="Company Logo"
                style="display: block;margin-left: auto; margin-right: auto;width: 58%;margin-top: 3px; margin-bottom: 2px;">
            <div style="text-align: center;font-size: 11px;line-height: 14px; color: black;">{{selectedBranch?.address}}
            </div>
            <div style="text-align: center;font-size: 11px;line-height: 15px; color: black;"> {{selectedBranch?.phone}}
            </div>
            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
                <tbody>
                    <tr>
                        <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">Invoice No</td>
                        <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;">Created Date
                        </td>
                    </tr>
                    <tr>
                        <td style="font-size: 10px;text-align: center; padding: 0px;">{{fund.invoice}}</td>
                        <td style="font-size: 10px;text-align: center; padding: 0px;"> {{fund.date | date:
                            'dd/MM/yyyy'}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <table
                style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">
                <thead
                    style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
                    <tr style="background-color: black;color: white; border: 1px solid black;">
                        <th style="width: 40px;   word-break: break-word; font-size: 10px;" colspan="2">Name</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">Pay</th>
                        <th style="width: 40px;  word-break: break-word; font-size: 10px;">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <span>
                        <tr>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;" colspan="2">
                                {{fullName}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.pay}}</td>
                            <td style="font-size: 9px;border:1px solid black;text-align: center;">{{fund.status}}</td>
                        </tr>
                    </span>
                    <tr>
                        <td></td>
                        <td style="font-size: 10px; text-align: center;  font-weight: bold; border-left: 1px solid; border-bottom: 1px solid;border-bottom: 1px solid;border-left: 1px solid;"
                            colspan="2">Total</td>
                        <td style="font-size: 10px;text-align: center; border-right: 1px solid;
                      border-bottom: 1px solid;">{{fund.pay}}</td>
                    </tr>
                </tbody>
            </table>
            <div
                style=" text-align: center;padding-top: 6px; font-size: 10px; font-weight: bold;color: black;white-space: nowrap;">
                Software
                Provided By Tecfolk 0332-5478182
            </div>
        </div>
    </div>
</div>